import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import pageHero from './pageHero';

// huseyinfiliz/leaderboard's page, patched when its bundle registers it.
const LEADERBOARD_PAGE = 'ext:huseyinfiliz/leaderboard/forum/components/LeaderboardPage';

/**
 * The leaderboard gets the theme's page hero, like Tags, Messages and Deck:
 * its name as the title, without the trophy, and a subtitle.
 */
export default function leaderboardPage() {
  override(LEADERBOARD_PAGE, 'hero', function () {
    const name = app.forum.attribute('huseyinfiliz-leaderboard.leaderboard_name') || 'Leaderboard';
    return pageHero(name, app.translator.trans('bimmerdock-theme.forum.leaderboard.subtitle'), 'LeaderboardHero');
  });
}